export class Tarif {
    Description: DescriptionTarif[];
    Color: string[];
    Name: string;
    Subtarif: InterfaceSubtarif[];
}

export class DescriptionTarif {
  Property: string;
}

export class InterfaceSubtarif {
  Description: string;
  DurationDays: number;
  Id_Tarif: number;
  Name: string;
  Price: number;
}





// WEBPACK FOOTER //
// ./src/app/shared/models/tarif-model.ts